export default function extractAction() {
  return this.updateAction ? this.updateAction : undefined;
}
